import React from "react";
import { getViewportLayoutMm } from "../../engine/sheetLayoutUtils";

const VIEW_MODE_OPTIONS = [
  { value: "hiddenLine", label: "Hidden Line" },
  { value: "wireframe", label: "Wireframe" },
  { value: "realistic", label: "Realistic" },
  { value: "xray", label: "X-Ray" },
  { value: "full", label: "Full" },
  { value: "boards", label: "Boards" },
  { value: "box", label: "Box" },
];

const SCALE_OPTIONS = [5, 10, 20, 25, 50, 75, 100];

export default function SheetToolbar({
  activeViewportId,
  selectedViewport,
  selectedView,
  sheetZoom,
  onSheetZoomChange,
  onFitSheet,
  onDeactivateViewport,
  onAddFrontView,
  onAddTopView,
  onAddSection,
  onUpdateSelectedViewport,
  onUpdateSelectedView,
  onAlignSelectedViewport,
  onAutoDimensions,
  drawingTool,
  onDrawingToolChange,
  onDeleteSelectedView,
  selectedAnnotationId,
onDeleteSelectedAnnotation,
onFitSelectedView,
onSaveDrawing,
}) {
  const hasViewport = Boolean(selectedViewport);
 const selectedLayout = selectedViewport
  ? getViewportLayoutMm(selectedViewport)
  : { xMm: 0, yMm: 0, widthMm: 0, heightMm: 0 };

  function updateViewportNumber(key, value) {
    if (!hasViewport) return;

    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return;

    onUpdateSelectedViewport?.({
      [key]: parsed,
    });
  }

  return (
    <div className="h-14 border-b bg-white flex items-center gap-2 px-3 overflow-x-auto">
      <div className="font-semibold text-sm text-slate-700 mr-2 shrink-0">
        Documentation
      </div>

      <button
        className="px-3 py-1.5 rounded border text-sm hover:bg-slate-50 shrink-0"
        onClick={onAddFrontView}
      >
        + Front
      </button>

      <button
        className="px-3 py-1.5 rounded border text-sm hover:bg-slate-50 shrink-0"
        onClick={onAddTopView}
      >
        + Top
      </button>

      <button
        className="px-3 py-1.5 rounded border text-sm hover:bg-slate-50 shrink-0"
        onClick={onAddSection}
      >
        + Section
      </button>

      <button
  disabled={!hasViewport}
  type="button"
  onClick={() => onDeleteSelectedView?.()}
  className="px-2 py-1.5 rounded border text-sm text-red-600 disabled:opacity-40 shrink-0"
>
  Delete View
</button>

<button
  type="button"
  onClick={() => onSaveDrawing?.()}
  className="px-2 py-1.5 rounded border text-sm shrink-0"
>
  Save Drawing
</button>

      <button
  disabled={!hasViewport}
  type="button"
  onClick={() => onAutoDimensions?.()}
  className="px-2 py-1.5 rounded border text-sm disabled:opacity-40 shrink-0"
>
  Auto Dimensions
</button>

<button
  disabled={!hasViewport}
  type="button"
  onClick={() => onFitSelectedView?.()}
  className="px-2 py-1.5 rounded border text-sm disabled:opacity-40 shrink-0"
>
  Fit View
</button>

<button
  type="button"
  onClick={() =>
    onDrawingToolChange?.(
      drawingTool === "dimension" ? "select" : "dimension"
    )
  }
  className={[
    "px-2 py-1.5 rounded border text-sm shrink-0",
    drawingTool === "dimension"
      ? "bg-blue-600 text-white border-blue-600"
      : "bg-white text-slate-700",
  ].join(" ")}
>
  Dimension Tool
</button>

<button
  disabled={!selectedAnnotationId}
  type="button"
  onClick={() => onDeleteSelectedAnnotation?.()}
  className="px-2 py-1.5 rounded border text-sm text-red-600 disabled:opacity-40 shrink-0"
>
  Delete Annotation
</button>

<button
  type="button"
  onClick={() =>
    onDrawingToolChange?.(
      drawingTool === "section" ? "select" : "section"
    )
  }
  className={[
    "px-2 py-1.5 rounded border text-sm shrink-0",
    drawingTool === "section"
      ? "bg-blue-600 text-white border-blue-600"
      : "bg-white text-slate-700",
  ].join(" ")}
>
  Section Tool
</button>

      <div className="h-7 w-px bg-slate-200 mx-2 shrink-0" />

      <select
        disabled={!hasViewport}
        value={selectedView?.viewMode || "hiddenLine"}
        onChange={(e) =>
          onUpdateSelectedView?.({
            viewMode: e.target.value,
          })
        }
        className="px-2 py-1.5 rounded border text-sm bg-white disabled:opacity-40 shrink-0"
      >
        {VIEW_MODE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <select
        disabled={!hasViewport}
        value={Number(selectedView?.scale || 20)}
        onChange={(e) => {
  const nextScale = Number(e.target.value);

  onUpdateSelectedView?.((view) => ({
    scale: nextScale,
    projection: view.projection || {
      originWorld: { x: 0, y: 0, z: 0 },
    },
    camera: null,
  }));
}}
        className="px-2 py-1.5 rounded border text-sm bg-white disabled:opacity-40 shrink-0"
      >
        {SCALE_OPTIONS.map((scale) => (
          <option key={scale} value={scale}>
            1:{scale}
          </option>
        ))}
      </select>

      <div className="h-7 w-px bg-slate-200 mx-2 shrink-0" />

      <label className="text-xs text-slate-500 shrink-0">X</label>
<input
  disabled={!hasViewport}
  type="number"
  value={hasViewport ? Math.round(selectedLayout.xMm) : ""}
  onChange={(e) => updateViewportNumber("xMm", e.target.value)}
  className="w-16 px-2 py-1.5 rounded border text-sm disabled:opacity-40"
/>

<label className="text-xs text-slate-500 shrink-0">Y</label>
<input
  disabled={!hasViewport}
  type="number"
  value={hasViewport ? Math.round(selectedLayout.yMm) : ""}
  onChange={(e) => updateViewportNumber("yMm", e.target.value)}
  className="w-16 px-2 py-1.5 rounded border text-sm disabled:opacity-40"
/>

<label className="text-xs text-slate-500 shrink-0">W</label>
<input
  disabled={!hasViewport}
  type="number"
  value={hasViewport ? Math.round(selectedLayout.widthMm) : ""}
  onChange={(e) => updateViewportNumber("widthMm", e.target.value)}
  className="w-16 px-2 py-1.5 rounded border text-sm disabled:opacity-40"
/>

<label className="text-xs text-slate-500 shrink-0">H</label>
<input
  disabled={!hasViewport}
  type="number"
  value={hasViewport ? Math.round(selectedLayout.heightMm) : ""}
  onChange={(e) => updateViewportNumber("heightMm", e.target.value)}
  className="w-16 px-2 py-1.5 rounded border text-sm disabled:opacity-40"
/>

{selectedView?.type === "section" ? (
  <>
    <label className="text-xs text-slate-500 shrink-0">Plane</label>
<input
  type="number"
  value={Number(selectedView?.sectionPlane?.value || 0)}
  onChange={(e) =>
    onUpdateSelectedView?.((view) => {
      const nextValue = Number(e.target.value || 0);
      const oldPlane = view.sectionPlane || {};

      return {
        sectionPlane: {
          ...oldPlane,
          value: nextValue,
          start: {
            ...(oldPlane.start || {}),
            z: nextValue,
          },
          end: {
            ...(oldPlane.end || {}),
            z: nextValue,
          },
        },
        camera: null,
      };
    })
  }
  className="w-20 px-2 py-1.5 rounded border text-sm"
/>

    <label className="text-xs text-slate-500 shrink-0">Depth</label>
    <input
      type="number"
      value={Number(selectedView?.sectionPlane?.depth || 1000)}
      onChange={(e) =>
        onUpdateSelectedView?.((view) => ({
          sectionPlane: {
            ...(view.sectionPlane || {}),
            depth: Number(e.target.value || 0),
          },
          camera: null,
        }))
      }
      className="w-20 px-2 py-1.5 rounded border text-sm"
    />

    <select
      value={selectedView?.sectionPlane?.direction || "front"}
      onChange={(e) =>
        onUpdateSelectedView?.((view) => ({
          sectionPlane: {
            ...(view.sectionPlane || {}),
            direction: e.target.value,
          },
          camera: null,
        }))
      }
      className="px-2 py-1.5 rounded border text-sm bg-white"
    >
      <option value="front">Front</option>
      <option value="back">Back</option>
    </select>

    <label className="text-xs text-slate-500 shrink-0">Angle</label>
<input
  type="number"
  value={Number(selectedView?.sectionPlane?.angleDeg || 0)}
  onChange={(e) =>
    onUpdateSelectedView?.((view) => {
      const angleDeg = Number(e.target.value || 0);
      const plane = view.sectionPlane || {};
      const value = Number(plane.value || 0);

      const length = 1000;
      const rad = (angleDeg * Math.PI) / 180;

      const dx = Math.cos(rad) * length / 2;
      const dz = Math.sin(rad) * length / 2;

      return {
        sectionPlane: {
          ...plane,
          angleDeg,
          start: {
            x: -dx,
            z: value - dz,
          },
          end: {
            x: dx,
            z: value + dz,
          },
        },
        camera: null,
      };
    })
  }
  className="w-20 px-2 py-1.5 rounded border text-sm"
/>

    <button
  type="button"
  onClick={() =>
    onUpdateSelectedView?.((view) => {
      const oldPlane = view.sectionPlane || {};
      const current = oldPlane.direction || "front";

      return {
        sectionPlane: {
          ...oldPlane,
          direction: current === "front" ? "back" : "front",
        },
        camera: null,
      };
    })
  }
  className="px-2 py-1.5 rounded border text-sm"
>
  Flip
</button>
  </>
) : null}

      <div className="h-7 w-px bg-slate-200 mx-2 shrink-0" />

      <button
        disabled={!hasViewport}
        onClick={() => onAlignSelectedViewport?.("left")}
        className="px-2 py-1.5 rounded border text-sm disabled:opacity-40 shrink-0"
      >
        Align L
      </button>

      <button
        disabled={!hasViewport}
        onClick={() => onAlignSelectedViewport?.("right")}
        className="px-2 py-1.5 rounded border text-sm disabled:opacity-40 shrink-0"
      >
        Align R
      </button>

      <button
        disabled={!hasViewport}
        onClick={() => onAlignSelectedViewport?.("top")}
        className="px-2 py-1.5 rounded border text-sm disabled:opacity-40 shrink-0"
      >
        Align T
      </button>

      <button
        disabled={!hasViewport}
        onClick={() => onAlignSelectedViewport?.("bottom")}
        className="px-2 py-1.5 rounded border text-sm disabled:opacity-40 shrink-0"
      >
        Align B
      </button>

      <button
        disabled={!hasViewport}
        onClick={() => onAlignSelectedViewport?.("centerH")}
        className="px-2 py-1.5 rounded border text-sm disabled:opacity-40 shrink-0"
      >
        Center H
      </button>

      <button
        disabled={!hasViewport}
        onClick={() => onAlignSelectedViewport?.("centerV")}
        className="px-2 py-1.5 rounded border text-sm disabled:opacity-40 shrink-0"
      >
        Center V
      </button>

      <div className="ml-auto flex items-center gap-2 shrink-0">
        {activeViewportId ? (
          <>
            <span className="text-xs text-blue-600">
              Active: {activeViewportId}
            </span>
            <button
              className="px-3 py-1.5 rounded bg-blue-600 text-white text-sm"
              onClick={onDeactivateViewport}
            >
              Exit View
            </button>
          </>
        ) : (
          <span className="text-xs text-slate-500">
            Select viewport to edit · Double click to activate
          </span>
        )}
      </div>

      <div className="h-7 w-px bg-slate-200 mx-2 shrink-0" />

<button
  type="button"
  onClick={() => onSheetZoomChange?.(0.25)}
  className="px-2 py-1.5 rounded border text-sm shrink-0"
>
  25%
</button>


<button
  type="button"
  onClick={() => onSheetZoomChange?.(0.5)}
  className="px-2 py-1.5 rounded border text-sm shrink-0"
>
  50%
</button>

<button
  type="button"
  onClick={() => onSheetZoomChange?.(1.00)}
  className="px-2 py-1.5 rounded border text-sm shrink-0"
>
  100%
</button>

<button
  type="button"
  onClick={() => onSheetZoomChange?.(1.50)}
  className="px-2 py-1.5 rounded border text-sm shrink-0"
>
  150%
</button>

<button
  type="button"
  onClick={() => onSheetZoomChange?.(2.00)}
  className="px-2 py-1.5 rounded border text-sm shrink-0"
>
  200%
</button>

<button
  type="button"
  onClick={() => onFitSheet?.()}
  className="px-2 py-1.5 rounded border text-sm shrink-0"
>
  Fit Page
</button>

<span className="text-xs text-slate-500 shrink-0">
  Sheet {Math.round((sheetZoom || 1) * 100)}%
</span>
    </div>
  );
}